const categories = [
  { title: '热门电影', desc: '院线大片高清上线', icon: 'ri-movie-2-fill', count: '2,340部', color: 'primary' },
  { title: '电视剧集', desc: '国剧韩剧美剧日剧', icon: 'ri-tv-2-fill', count: '5,120部', color: 'accent' },
  { title: '综艺娱乐', desc: '热门综艺全程高能', icon: 'ri-emotion-laugh-fill', count: '890部', color: 'secondary' },
  { title: '动漫番剧', desc: '日漫国漫全网收录', icon: 'ri-ghost-2-fill', count: '3,450部', color: 'primary' },
  { title: '纪录片', desc: '自然人文科技探索', icon: 'ri-earth-fill', count: '1,200部', color: 'accent' },
  { title: '动作大片', desc: '肾上腺素飙升体验', icon: 'ri-sword-fill', count: '4,560部', color: 'secondary' },
  { title: '悬疑惊悚', desc: '烧脑剧情高能反转', icon: 'ri-search-eye-line', count: '2,100部', color: 'primary' },
  { title: '喜剧专区', desc: '爆笑不断欢乐解压', icon: 'ri-emotion-happy-fill', count: '3,800部', color: 'accent' },
  { title: '经典重温', desc: '影史不朽名作珍藏', icon: 'ri-vip-crown-fill', count: '1,870部', color: 'secondary' },
];

export default function IndexSection() {
  const colorMap: Record<string, { bg: string; text: string; border: string }> = {
    primary: { bg: 'bg-primary-500/10', text: 'text-primary-500', border: 'border-primary-500/30' },
    accent: { bg: 'bg-accent-500/10', text: 'text-accent-500', border: 'border-accent-500/30' },
    secondary: { bg: 'bg-secondary-100/80', text: 'text-secondary-500', border: 'border-secondary-300/60' },
  };

  return (
    <section id="index" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-1 h-6 bg-primary-500 rounded-full"></span>
          <h2 className="text-foreground-900 font-heading text-2xl md:text-3xl font-bold">
            影视索引
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat, idx) => {
            const c = colorMap[cat.color];
            return (
              <a
                key={idx}
                href="#cards"
                className={`group flex items-start gap-4 p-4 md:p-5 rounded-lg border ${c.border} ${c.bg} hover:scale-[1.02] transition-transform cursor-pointer`}
              >
                <span className={`w-10 h-10 md:w-11 md:h-11 rounded-lg flex items-center justify-center flex-shrink-0 ${c.bg} ${c.text}`}>
                  <i className={`${cat.icon} text-lg md:text-xl`}></i>
                </span>
                <div className="min-w-0 flex-1">
                  <h3 className="text-foreground-900 font-heading text-base md:text-lg font-bold mb-1">
                    {cat.title}
                  </h3>
                  <p className="text-foreground-500 text-xs md:text-sm mb-1.5">{cat.desc}</p>
                  <span className={`text-xs font-medium ${c.text}`}>{cat.count}</span>
                </div>
                <span className="text-foreground-400 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0 self-center">
                  <i className="ri-arrow-right-s-line text-lg"></i>
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}